// extracted by mini-css-extract-plugin
export var chip = "_co-0";
export var filterDropdown = "_co-5";
export var filterItem = "_co-6";
export var icon = "_co-1";
export var removeButton = "_co-3";
export var removeIcon = "_co-4";
export var separator = "_co-2";